import { request } from "../util/request"
import { possible_duplicate_api_v1_band_posts_path } from "../routes"

export interface PossibleDuplicatePost {
  id: number
  title: string
  nada_path: string
  published_at: string
  location_display_name: string | null
}

export interface PossibleDuplicateResponse {
  duplicate: PossibleDuplicatePost | null
}

export async function checkPossibleDuplicateEvent(
  bandId: number,
  startDatetime: string,
  venueBandId?: number | null,
): Promise<PossibleDuplicateResponse> {
  return request({
    queryKey: [
      "possibleDuplicateEvent",
      {
        path: possible_duplicate_api_v1_band_posts_path(bandId, {
          start_datetime: startDatetime,
          ...(venueBandId ? { venue_band_id: venueBandId } : {}),
        }),
        options: { method: "GET" },
      },
    ],
  })
}
